import styled, { css } from 'styled-components';
import { rtl } from '../../../utils/language';

export const DateColumn = styled.div`
  flex: 2;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;

  & .date-title {
    font-size: 8px;
    display: none;
  }

  @media screen and (max-width: 1024px) {
    & .date-title {
      display: block;
    }
    ${({ submission }) => {
      if (!submission)
        return `
          &.submitted-on-date-column, &.evaluated-on-date-column {
            display:none;
          }
        `;
      if (
        submission.submittedOn &&
        submission.evaluatedOn &&
        submission.returnedOn
      ) {
        return `
          &.submitted-on-date-column, &.evaluated-on-date-column {
            display:none;
          }
        `;
      }
      if (
        submission.submittedOn &&
        submission.evaluatedOn &&
        !submission.returnedOn
      ) {
        return `
          &.submitted-on-date-column, &.returned-on-date-column {
            display:none;
          }
        `;
      }
      if (
        submission.submittedOn &&
        !submission.evaluatedOn &&
        !submission.returnedOn
      ) {
        return `
          &.returned-on-date-column, &.evaluated-on-date-column {
            display:none;
          }
        `;
      }
      if (
        !submission.submittedOn &&
        submission.evaluatedOn &&
        submission.returnedOn
      ) {
        return `
          &.submitted-on-date-column, &.evaluated-on-date-column {
            display:none;
          }
        `;
      }

      return '';
    }};
  }
`;

const svgHoverOver = css`
  & svg {
    transition: box-shadow 0.2s;
    border-radius: 50%;
    &[data-testid='attachment-type-icon'] {
      border-radius: 0;
    }

    &:hover {
      box-shadow: 0 0 4px 0 #565656;
    }
  }
`;

export const SectionItemControls = styled.div`
  flex: 2;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--half-spacing-unit);

  // unsets style from app.css which has global * selector;
  & * {
    min-width: unset;
  }

  & > div {
    display: flex;
    align-items: center;
    ${svgHoverOver};
  }

  & .grade-score-wrapper {
    max-height: 23px;
  }
`;

export const SectionItemStyled = styled.div`
  border-radius: 6px;
  border: solid 1px #d9d9d9;
  padding: var(--quarter-spacing-unit) var(--half-spacing-unit);
  margin-bottom: var(--quarter-spacing-unit);
  transition: box-shadow 0.2s;
  display: flex;
  font-size: 14px;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};

  &:hover {
    box-shadow: ${props =>
      props.clickable ? '0 1px 5px 0 rgba(23, 28, 33, 0.3)' : 'none'};
    border-color: ${props => (props.clickable ? '#21bcb6' : '#d9d9d9')};
  }

  & .student-info {
    flex: 2;
    font-family: var(--font-family-opensans);
    font-weight: 700;
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: 10px;

    & > .student-avatar {
      display: flex;
      flex-shrink: 0;
    }
    & > .student-name {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;

export const SectionHeaderStyled = styled.div`
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background-color: #ededed;
  width: 100%;
  max-height: 50px;
  height: 50px;
  padding: 11px 14px;
  margin-bottom: var(--half-spacing-unit);

  font-size: 16px;
  font-family: var(--font-family-opensans);
  font-weight: 700;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: ${props =>
      props.clickable ? '0px 0px 0px 2px #21bcb6' : 'none'};
  }

  & .students-count {
    margin-left: 5px;
    margin-right: var(--quarter-spacing-unit);
    ${rtl`
      margin-right: 5px;
      margin-left: var(--quarter-spacing-unit);
  `};
  }

  & .toggle-icon {
    margin: 0 var(--quarter-spacing-unit);

    & svg {
      transition: transform 0.2s;
      transform: translateY(2px)
        ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    }
  }

  & .student-info {
    display: flex;
    align-items: center;
  }

  & .group-control-items {
    display: flex;
    ${svgHoverOver};
  }
`;

export const SectionItemsContainer = styled.div``;
export const StudentListSectionStyled = styled.div`
  margin-bottom: 30px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const TeamIcon = styled.i`
  margin: 0px 5px;
`;
